export default "__VITE_ASSET__97c6fd0f__"